import { DataTable, type DataTableColumn } from "@bruntworkwear-apps/ui";
import { money, quantity } from "@/shared/lib";
import type { CostedLine } from "@/shared/api";
import styles from "../PoBreakdown.module.css";

const COLUMNS: DataTableColumn<CostedLine>[] = [
  { key: "row", header: "Row", render: (line) => line.row_number, numeric: true, width: "4.5rem" },
  { key: "receipt", header: "Receipt", render: (line) => line.document_number },
  { key: "item", header: "Item", render: (line) => line.item, secondary: true },
  {
    key: "description",
    header: "Description",
    render: (line) => (
      <span className={styles.description} title={line.description}>
        {line.description || "—"}
      </span>
    ),
  },
  { key: "qty", header: "Qty", render: (line) => quantity(line.quantity), numeric: true },
  { key: "landing", header: "Landing", render: (line) => money(line.landing_cost), numeric: true },
  {
    key: "customs",
    header: "Customs",
    render: (line) =>
      line.is_domestic ? <span className={styles.domestic}>USA</span> : money(line.customs_total),
    numeric: true,
  },
];

/**
 * The receipt lines this order was costed from, straight out of the WC export.
 *
 * A private sub-view of PoBreakdown.
 */
export function ReceiptLinesView({ lines }: { lines: CostedLine[] }) {
  return (
    <DataTable
      rows={lines}
      columns={COLUMNS}
      rowKey={(line) => String(line.row_number)}
      rowTone={(line) => (line.is_domestic ? "muted" : "default")}
      maxHeight="18rem"
      emptyMessage="No costed lines for this order."
    />
  );
}
